import React from 'react';
import { useEffect } from 'react';
import './NotFound.css';

const NotFound = () => {
    useEffect(() => {
        document.title = "404"
    })
    return (
        <div className="text-dark">
            <div className="notfound-content">
                <div className="notfound-layer">
                    <h1 className="text-danger text-center">404</h1>
                    <h3 className="text-dark">صفحه مورد نظر یافت نشد</h3>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
